/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import styled from 'styled-components';

import sytled from 'styled-components';
export const Img = styled.img`
  width: 30px;
  margin-right: 5px;
`;

export const UserFormTitleStyle = {
  fontSize: '25px',
  fontWeight: 'bold',
};
